import { ChangeDetectionStrategy, Component, signal } from '@angular/core';

@Component({
  selector: 'mop-footer',
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterComponent {
  protected currentYear = signal(new Date().getFullYear());
}
